import { render } from "./IngredientsStatus.vue?vue&type=template&id=02338e28"
import script from "./IngredientsStatus.vue?vue&type=script&lang=js"
export * from "./IngredientsStatus.vue?vue&type=script&lang=js"
script.render = render

export default script